import { StepProps } from '@components/connectors/types'
import { Alert, Button, Flex } from 'antd'
import { ContentWrapper } from './ContentWrapper'

export const SeatingAreasMappingSharedDisclaimer = ({ onPrev }: StepProps) => {
  return (
    <>
      <ContentWrapper>
        <Alert
          title={`The seating areas mapping is shared between product configurations. In order to update it edit the Mobile application configuration`}
          type="info"
        />
      </ContentWrapper>
      <Flex justify="flex-end" gap={8}>
        <Button onClick={onPrev}>Previous</Button>
      </Flex>
    </>
  )
}
